import axios from "axios";

export const getABTestClientIds = () =>
  axios.get(import.meta.env.VITE_BACKEND_API + "/api/abtest/client/list").then((res) => res.data);

export const getClientABTests = (clientId: string) =>
  axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/abtest/client/tests?clientId=" + clientId)
    .then((res) => res.data);

export const getTestMetrics = (clientId: string, featureKey: string) =>
  axios
    .get(
      `${
        import.meta.env.VITE_BACKEND_API
      }/api/abtest/client/metrics?clientId=${clientId}&featureKey=${encodeURIComponent(featureKey)}`,
    )
    .then((res) => res.data);
